import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './ParticipantBadge.scss';

import { getInitials, getAdjustedName } from '../../helpers/formatting';

const ParticipantBadge = (props) => {
  const { participant, specialNameFormatting, isSelected, isOtherSelected, clickParticipant } = props;
  return (
    <div
      onClick={() => clickParticipant(participant)}
      className={cn('participant-badge-outer-container', { selected: isSelected, 'other-selected': isOtherSelected })}
    >
      <div className='image'>{getInitials(participant.name)}</div>
      <div className='name'>
        {specialNameFormatting ? specialNameFormatting(getAdjustedName(participant.name)) : getAdjustedName(participant.name)}
      </div>
    </div>
  );
};

ParticipantBadge.propTypes = {
  participant: PropTypes.object.isRequired,
  clickParticipant: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isOtherSelected: PropTypes.bool.isRequired,
  specialNameFormatting: PropTypes.func.isRequired,
};

export default ParticipantBadge;
